import script from "./WebinarReplayPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarReplayPlayer.vue?vue&type=script&setup=true&lang=js"

import "./WebinarReplayPlayer.vue?vue&type=style&index=0&id=7a83c49d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a83c49d"]])

export default __exports__